import { gql } from "@apollo/client";

export const GET_COMBOS_VISITAS = gql`
query GetCombosVisitas {
    combosVisitas {
        idComboVisita
        campo
    }
}`;

export default GET_COMBOS_VISITAS;

const adaptComboVisita = (combo) => ({ id: combo.idComboVisita, comboName: combo.campo });

export const adaptCombosVisitas = (data) => {
  return structuredClone(data?.combosVisitas).
  map((combo) => adaptComboVisita(combo));
};